import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link, useLocation } from 'react-router-dom';
import { ZoomInfoService } from 'service/zoominfo.service';
import zeplinColor from 'theme/Color';
import Card from './Card';

const News = () => {
  const theme = useTheme();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState(false);

  const getCompanyNews = async (id = '', page = 1) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getCompanyNews(id, page);
      console.log(res);
      setData(res?.data);
      setPageNumber((prev) => prev + 1);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError(false);
  };

  useEffect(() => {
    getCompanyNews(location?.pathname.split('/')[2] || '');
  }, [location?.pathname]);

  return (
    <Box sx={{ display: 'flex', gap: { xs: '20px', xl: '32px' }, height: 'calc(100vh - 350px)' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 1,
          }}
        >
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '5rem',
                backgroundColor: zeplinColor.Neutral4,
              }}
            />
          ) : (
            <Typography variant='responsiveHeading3'>News</Typography>
          )}
          <InfiniteScroll
            dataLength={Math.abs(data?.items?.length / 3) || 0}
            loader={
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <></>
              </Box>
            }
            next={() => {
              getCompanyNews(location?.pathname.split('/')[2] || '', pageNumber);
            }}
            hasMore={data?.items?.length < data?.maxResults}
            height={'calc(100vh - 330px)'}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: '100%',
            }}
          >
            {(!data || !data?.data?.length) && !loading ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flex: 1,
                  height: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} alt='no zoominfo results' />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No news yet
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'grid',

                  gridTemplateColumns: {
                    // xs: 'repeat(2,1fr)',
                    // xl: 'repeat(3,1fr)',
                    xs: 'repeat(3, minmax(250px, 1fr))', // Responsive columns
                    sm: 'repeat(auto-fill, minmax(270px, 1fr))',
                    md: 'repeat(auto-fill, minmax(280px, 1fr))',
                    lg: 'repeat(auto-fill, minmax(290px, 1fr))',
                    xl: 'repeat(3, minmax(300px, 1fr))',
                  },
                  gap: '24px',
                  overflowY: 'auto',
                  gridAutoRows: '1fr',
                  gridAutoFlow: 'row',
                  flex: 1,
                }}
              >
                {loading
                  ? [1, 2, 3, 4, 5, 6, 7, 8].map((val) => <Card val={val} loading={loading} />)
                  : data?.data?.map((val: any) => (
                      <Link
                        to={val?.url}
                        rel='noopener noreferrer'
                        target='_blank'
                        style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                      >
                        <Card val={val} loading={loading} />
                      </Link>
                    ))}
              </Box>
            )}
          </InfiniteScroll>
        </Box>
      </Box>
      <CustomAlert
        open={error ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={error ? 'Something went wrong.' : ''}
            alertIcon={<img src='/assets/error.svg' width={24} height={24} alt='error' />}
            error={error}
          />
        }
        error={error}
      />
    </Box>
  );
};

export default News;
